function followQuickLinksSelection(form) {
    var actionableSelect = form.querySelector('select');
    window.location.href = actionableSelect.options[actionableSelect.selectedIndex].getAttribute("data-uri");
}

var quickLinksSelect = document.querySelectorAll('.block.quick-links form select');
for (let index = 0; index < quickLinksSelect.length; index++) {
    quickLinksSelect[index].addEventListener("change", function () {
        followQuickLinksSelection(quickLinksSelect[index].closest("form"));
    });
}